module.exports = __webpack_public_path__ + "f103abf536177860dcd73ed552df8c1a.svg";